import { AxiosInstance } from "axios";

// All the paths for this api domain.
export const basePath = "/financial-institutions";
export const financialInstitutionPaths = {
  getBrandVariant: (financialInstitutionId: string, brandVariantId: string) =>
    basePath + `/${financialInstitutionId}/brand-variants/${brandVariantId}`,
};

class FinancialInstitutionApi {
  api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  // Get financial institution brand variant by id or slug.
  // Get /financial-institutions/<financialInstitutionId>/brand-variants/<brandVariantId>
  getBrandVariant = (
    financialInstitutionId: string,
    brandVariantId: string
  ) => {
    return this.api.get(
      financialInstitutionPaths.getBrandVariant(
        financialInstitutionId,
        brandVariantId
      )
    );
  };
}

export default FinancialInstitutionApi;
